import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { AppUserProviders } from '@/AppUserProviders'
import { useAuth } from '@/Shared/ui/auth'
import { Spinner, useLoader } from '@/Shared/ui/loader'
import { ClientRouter, ScrollTopRouter, openNavigationRoutes, registerStepTwoRoute } from '@/Shared/ui/routers'
import { useUserData } from '@/User/ui/context'

const isAnOpenRoute = (location: string): boolean =>
  Object.values(openNavigationRoutes).some(route => location === route) || location.includes(registerStepTwoRoute)

const AppRouter = (): JSX.Element => {
  const location = useLocation()
  const { isLogged, logIn } = useAuth()
  const { getUserData, user } = useUserData()
  const { startLoading, stopLoading } = useLoader()

  const openRoute = isAnOpenRoute(location.pathname)

  useEffect(() => {
    const startApp = (): void => {
      startLoading()
      logIn()
      stopLoading()
    }
    if (!openRoute) startApp()
  }, [])

  useEffect(() => {
    if (isLogged) {
      startLoading()
      getUserData()
      stopLoading()
    }
  }, [isLogged])

  if (!openRoute && (!isLogged || !user.user)) {
    return <Spinner />
  }

  return (
    <AppUserProviders>
      <ScrollTopRouter>
        <ClientRouter />
      </ScrollTopRouter>
    </AppUserProviders>
  )
}

export { AppRouter }
